module.exports = __webpack_public_path__ + "static/media/DSC_5794.7a8ac917.jpg";